import { DataAmigavel } from '@/shared/utils/datas';
import { Document, Page, Text, View, } from '@react-pdf/renderer';
import { RelatorioNucleoDto } from '@/api.types';
import { stylesDefensoresNucleo } from './styles/defensores-nucleo.style';

interface IProps {
  dados: RelatorioNucleoDto[];
}

export default function DefensorPorNucleo({ dados }: IProps) {
  const agora = new Date();
  const dataHora = `${DataAmigavel(agora)} às ${agora.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;

  return (
    <Document>
      <Page size="A4" style={stylesDefensoresNucleo.page} orientation="landscape">
        <Text style={stylesDefensoresNucleo.title}>LISTA DE NÚCLEOS</Text>
        <View style={stylesDefensoresNucleo.table}>
          <View style={stylesDefensoresNucleo.tableRow} fixed>
            <Text style={[stylesDefensoresNucleo.headerCell, { width: '25%' }]}>NÚCLEOS</Text>
            <Text style={[stylesDefensoresNucleo.headerCell, { width: '45%' }]}>INTEGRANTES</Text>
            <Text style={[stylesDefensoresNucleo.headerCell, { width: '30%' }, stylesDefensoresNucleo.lastCell]}>ESTAGIÁRIOS</Text>
          </View>

          {dados.map((nucleo, index) => {
            const integrantes = (nucleo.lotacoes || [])
              .filter((lotacao) => !lotacao.estagio)
              .sort((a, b) => Number(b.diretor) - Number(a.diretor));

            const estagiarios = (nucleo.lotacoes || [])
              .filter((lotacao) => lotacao.estagio !== null && lotacao.estagio !== undefined)
              .sort((a, b) => Number(b.diretor) - Number(a.diretor));

            return (
              <View
                style={[stylesDefensoresNucleo.tableRow, index % 2 === 0 ? stylesDefensoresNucleo.tableRowOdd : stylesDefensoresNucleo.tableRowEven]}
                key={index}
                wrap={false}
              >
                <Text style={[stylesDefensoresNucleo.tableCell, { width: '25%' }]}>
                  {nucleo.nome}
                  {nucleo.resolucao ? `\n${nucleo.resolucao}` : ''}
                </Text>

                <View style={[stylesDefensoresNucleo.tableCell, { width: '45%' }]}>
                  {integrantes.map((lotacao, idx) => {
                    const diretor = lotacao.diretor ? ' - Diretor' : '';
                    const anotacao = lotacao.anotacao1 ? ` - ${lotacao.anotacao1}` : '';
                    let style = stylesDefensoresNucleo.integrante;
                    if (!lotacao.ativo) style = stylesDefensoresNucleo.inativo;
                    else if (lotacao.diretor) style = stylesDefensoresNucleo.nomeDiretor;

                    return (
                      <Text key={idx} style={style}>
                        {lotacao.defensor?.pessoa?.nome}{diretor}{anotacao}
                      </Text>
                    );
                  })}
                </View>

                <View style={[stylesDefensoresNucleo.tableCell, { width: '30%' }, stylesDefensoresNucleo.lastCell]}>
                  {estagiarios.map((lotacao, idx) => {
                    const diretor = lotacao.diretor ? ' - Diretor' : '';
                    const anotacao = lotacao.anotacao1 ? ` - (${lotacao.anotacao1})` : '';
                    let style = stylesDefensoresNucleo.integrante;
                    if (!lotacao.ativo) style = stylesDefensoresNucleo.inativo;
                    else if (lotacao.diretor) style = stylesDefensoresNucleo.nomeDiretor;

                    return (
                      <Text key={idx} style={style}>
                        {lotacao.estagio?.estagiario?.pessoa?.nome}{diretor}{anotacao}
                      </Text>
                    );
                  })}
                </View>
              </View>
            );
          })}
        </View>
        <Text style={stylesDefensoresNucleo.updated}>Emitido em: {dataHora}</Text>
      </Page>
    </Document>
  );
}
